function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_13124",
  width: 24,
  height: 24,
  fill: "#000072"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_68091",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_146486",
  d: "M6.487,9.026h12.49A1.256,1.256,0,0,0,20.341,7.6V6.887a1.256,1.256,0,0,0-1.364-1.424H6.487A1.273,1.273,0,0,0,5.123,6.887V7.6A1.256,1.256,0,0,0,6.487,9.026ZM8.6,19.528H16.86a2.142,2.142,0,0,0,2.4-2.373V10.126H6.208v7.029A2.138,2.138,0,0,0,8.6,19.528Zm1.7-6.539a.592.592,0,0,1-.61-.618V12.13a.583.583,0,0,1,.61-.618h4.859a.583.583,0,0,1,.61.618v.241a.587.587,0,0,1-.61.618Z",
  transform: "translate(-0.732 -0.78)"
}));

function SvgArchiveFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveFilled);
export default __webpack_public_path__ + "static/media/archive-filled.81844778.svg";
export { ForwardRef as ReactComponent };